import Text from "common/Typography/Text";
import Flex from "common/Boxes/Flex";
import ExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";
import React from "react";
import { useInactiveAccountWarning } from "@shared/features/trades/common/hooks";
import { useTheme } from "styled-components";

interface InactiveAccountWarningProps {
  isBots?: boolean;
  numItems?: number;
  numInvalidItems?: number;
}

const InactiveAccountWarning = ({
  isBots,
  numItems = 1,
  numInvalidItems = 1,
}: InactiveAccountWarningProps) => {
  const theme = useTheme();
  const { prefix, title } = useInactiveAccountWarning({
    isBots,
    numItems,
    numInvalidItems,
  });

  return (
    <div>
      <Text style={{ fontWeight: "500" }}>{title}</Text>
      <Flex style={{ marginTop: 6 }} $alignItems="flex-start">
        <ExclamationCircleOutlined
          style={{
            marginTop: 4,
            fontSize: 16,
            marginRight: 10,
            color: theme.colors.primaryGrey,
          }}
        />
        <Text>
          {prefix} might still be present on the exchange. You should manually
          cancel these orders on the exchange if you wish to remove them
          completely.
        </Text>
      </Flex>
    </div>
  );
};

export default InactiveAccountWarning;
